// utility function to remove existing active items from a CSV upload
// if the item exists but is not active or is a Draft, include its ID in the CSV row.
// by including the ID, the item will be updated (overridden) instead of creating a new duplicate item.
type CSVRow = Record<string, string | null | undefined>

// Bulk upload item (i.e. Deal, Facility, Entity)
interface BulkUploadItem {
  id?: string | null
  systemId?: string | null // Optional for all
  clientId?: string | null // Optional for deals/facilities
  internalId?: string | null // Optional for entities
  status?: string | null
}

export function removeExistingActives<T extends BulkUploadItem>(
  csvRows: CSVRow[],
  existingItems: T[],
): CSVRow[] {

  const activeStatuses = ['Approved', 'Submitted', 'Active']
  
  return csvRows
    .map(row => {
      const clientId = row['Internal Entity ID']?.toUpperCase() || row['Client ID']?.toUpperCase() || ''
      const systemId = row['System ID']?.toUpperCase() || ''
      const existingItem = existingItems.find(
        item =>
          item.clientId?.toUpperCase() === clientId ||
          item.internalId?.toUpperCase() === clientId ||
          item.systemId?.toUpperCase() === systemId,
      )

      // Skip if item exists and status is in activeStatuses
      if (existingItem && activeStatuses.includes(existingItem.status || '')) {
        return null // Mark for exclusion
      }

      // If item exists but status is not in activeStatuses, include its ID, so it can be edited
      const updatedRow: CSVRow = {
        ...row,
        ID: existingItem ? existingItem.id : row['ID'] || '',
      }
      return updatedRow
    })
    .filter((row): row is CSVRow => row !== null)
}
